import React, { Component } from 'react';

import { compose } from 'react-apollo';
import {withRouter} from 'react-router';

import StatisticsPage from 'Components/Statistics/StatisticsPage/StatisticsPage';

export default compose(
  withRouter,
)(StatisticsPage);